import { FormattedMessage } from "react-intl";
import React from "react";

// 離散程度 for dropdown
export const selectOpts = Array.from(Array(10).keys()).map((item) => ({
  key: `statistDispersion-${item + 1}`,
  value: String(item + 1),
  label: item + 1,
}));
